// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ef-0";
export var headerCellHover = "_ef-1";
export var readCellContainer = "_ef-2";
export var unreadIndicator = "_ef-3";